import { FlaskConical, ListOrdered, Stethoscope, Wind } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  { icon: Stethoscope, label: "Made by a Doctor", line: "Formulated by Dr. Shibina Shemim, BAMS, PGDAC" },
  { icon: FlaskConical, label: "Our Own Facility", line: "Made under our own manufacturing licence. Never outsourced." },
  { icon: Wind, label: "SLS & Paraben Free", line: "Across the hair range" },
  { icon: ListOrdered, label: "Ten Products Only", line: "We make what we would use ourselves." },
];

const TrustStrip = ({ dark = false }) => (
  <section className={`border-y ${dark ? "border-cream/10 bg-ink-deep text-cream" : "hairline bg-white/60"}`} data-testid="trust-strip">
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-px lg:grid-cols-4">
      {ITEMS.map((t, i) => (
        <Reveal key={t.label} delay={i * 0.08} className="px-6 py-8 md:px-10">
          <t.icon className={`h-5 w-5 ${dark ? "text-sage" : "text-sage-deep"}`} strokeWidth={1.5} />
          <p className="mt-4 font-serif text-lg italic">{t.label}</p>
          <p className={`mt-2 max-w-[230px] text-[12px] leading-relaxed ${dark ? "text-cream/60" : "text-ink/60"}`}>{t.line}</p>
        </Reveal>
      ))}
    </div>
  </section>
);

export default TrustStrip;
